import { Injector, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FooterComponent } from './footer.component';
import { ReactiveFormsModule } from '@angular/forms';
import { createCustomElement } from '@angular/elements';
import { DialogModule } from 'primeng/dialog';
import { IframeModalModule } from '../iframe-modal/iframe-modal.module';
import { PipesModule } from '../../pipes/pipes.module';
import { AssetPipe } from '../../pipes/asset.pipe';

@NgModule({
  declarations: [FooterComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    DialogModule,
    IframeModalModule,
    PipesModule,
  ],
})
export class FooterModule {
  static initialize(injector: Injector) {
    const customComponent = createCustomElement(FooterComponent, {
      injector: injector,
    });
    customElements.define('ds-orderform-footer', customComponent);
  }
}
